module.exports = __webpack_public_path__ + "static/media/PJ Parker_1580326682832.48e6dc97.jpg";